module.exports = __webpack_public_path__ + "static/img/order1.cbbac34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order1.png
// module id = Uu/x
// module chunks = 1